const Countdown = (function() {
  'use strict';

  function init(date, id) {
    let end = new Date(date);
    let _second = 1000;
    let _minute = _second * 60;
    let _hour = _minute * 60;
    let _day = _hour * 24;
    let timer;

    function showRemaining() {
      const now = new Date();
      const distance = end - now;
      if (distance < 0) {
        clearInterval(timer);
        $(id).remove();
        return;
      }
      $(id).show();
      let days = Math.floor(distance / _day);
      let hours = Math.floor((distance % _day) / _hour);
      let minutes = Math.floor((distance % _hour) / _minute);
      let seconds = Math.floor((distance % _minute) / _second);

      $(id)
        .find('.counter--days')
        .text(days);
      $(id)
        .find('.counter--hours')
        .text(hours);
      $(id)
        .find('.counter--minutes')
        .text(minutes);
      $(id)
        .find('.counter--seconds')
        .text(seconds);
    }

    timer = setInterval(showRemaining, 1000);
  }

  return {
    init: init,
  };
})();

export { Countdown as default };



// WEBPACK FOOTER //
// ./client_src/js/modules/Countdown.js